import { TemplateEntity } from '@entities/Template/Types';
import TemplateCard from '@shared/Widgets/TemplateCard/TemplateCard';
import css from './TemplatesList.module.css';
import { ViewAllTemplatesPreview } from '@modules/Landing/Shared/Ui/ViewAllTemplatesPreview/ViewAllTemplatesPreview';
import { TemplateCategoryEnum } from '@shared/Enums/TemplateCategoryEnum';

interface TemplatesListProps {
    templates: TemplateEntity[];
}

export const TemplatesList: React.FC<TemplatesListProps> = ({ templates }) => {
    return (
        <section className={css.section}>
            <ViewAllTemplatesPreview />
            {templates.map(template => (
                <TemplateCard
                    template={template}
                    category={TemplateCategoryEnum.DIY}
                    isLandingExample={true}
                    extraCardDescriptionClassName={css.cardDescription}
                    extraTemplateInfoPlaceholderBlockClassName={
                        css.templateInfo
                    }
                />
            ))}
        </section>
    );
};
